import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Language gate background image
const gateBackground = 'https://customer-assets.emergentagent.com/job_seoul-party-spot/artifacts/u18l3cic_file_0000000049bc71fab8caa979091f5fc7.png';

const LanguageGate = () => {
  const { selectLanguage } = useLanguage();

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        backgroundImage: `url(${gateBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/80" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-6">
        {/* Logo/Title */}
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-2">
          강남놀이터 코엑스점
        </h1>
        <p className="text-[#00FFD1] text-lg md:text-xl mb-12">
          Private Rooftop Party Clubhouse in Gangnam
        </p>
        
        {/* Subtitle */}
        <div className="mb-8">
          <p className="text-white/80 text-base md:text-lg mb-1">언어를 선택해주세요</p>
          <p className="text-white/60 text-sm md:text-base">Please choose your language</p>
        </div>
        
        {/* Language Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => selectLanguage('ko')}
            className="px-12 py-4 bg-[#00FFD1] text-black font-semibold text-lg transition-all duration-300 hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] min-w-[200px]"
            style={{ borderRadius: 0 }}
          >
            🇰🇷 한국어
          </button>
          <button
            onClick={() => selectLanguage('en')}
            className="px-12 py-4 bg-white/10 text-white font-semibold text-lg transition-all duration-300 hover:bg-white hover:text-black min-w-[200px]"
            style={{ borderRadius: 0 }}
          >
            🇺🇸 English
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageGate;